import { colors } from '~/styles/colors';
import { HealthCountInfo, HealthUnitsInfo } from '../contexts/HealthDataContext';
import { HealthVariant } from '../Health/components/UnitsInfo/types';
import { GetOverviewUnitHealth } from '../types';

export function parseHealthData(data: GetOverviewUnitHealth): HealthCountInfo {
  return {
    alert: data.COUNT_TOTAL_ALERT_UNITS,
    critical: data.COUNT_TOTAL_CRITICAL_UNITS,
    healthy: data.COUNT_TOTAL_HEALTHY_UNITS,
    inoperative: data.COUNT_TOTAL_INOPERANT_UNITS,
  };
}

export function parseUnits(data: GetOverviewUnitHealth['UNITS']): HealthUnitsInfo {
  return data.map((item) => ({
    id: item.UNIT_ID,
    lat: item.UNIT_LAT ? Number(item.UNIT_LAT) : null,
    lon: item.UNIT_LON ? Number(item.UNIT_LON) : null,
    name: item.UNIT_NAME,
    state: item.STATE_NAME,
    city: item.CITY_NAME,
    health: parseUnitHealth(item.UNIT_INDEX),
    machines: {
      alert: item.COUNT_ALERT_MACHINES,
      critical: item.COUNT_CRITICAL_MACHINES,
      healthy: item.COUNT_HEALTHY_MACHINES,
      inoperative: item.COUNT_INOPERANT_MACHINES,
    },
  }));
}

function parseUnitHealth(unitIndex: number): HealthVariant {
  if (unitIndex >= 0.85) return 'healthy';
  if (unitIndex >= 0.45 && unitIndex < 0.85) return 'alert';
  if (unitIndex > 0 && unitIndex < 0.45) return 'critical';
  return 'inoperative';
}

export function parseHealthColor(health: HealthVariant): string {
  switch (health) {
    case 'alert': return colors.state.warning.base;
    case 'critical': return colors.state.danger.base;
    case 'healthy': return colors.state.success.base;
    default: return colors.icon['soft-400'];
  }
}
